var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20825 15.6249H4.16659C3.61405 15.6249 3.08415 15.4054 2.69345 15.0147C2.30275 14.624 2.08325 14.0941 2.08325 13.5416V4.16659C2.08325 3.61405 2.30275 3.08415 2.69345 2.69345C3.08415 2.30275 3.61405 2.08325 4.16659 2.08325H13.5416C14.0941 2.08325 14.624 2.30275 15.0147 2.69345C15.4054 3.08415 15.6249 3.61405 15.6249 4.16659V5.20825M11.4583 9.37492H20.8333C21.9838 9.37492 22.9166 10.3077 22.9166 11.4583V20.8333C22.9166 21.9838 21.9838 22.9166 20.8333 22.9166H11.4583C10.3077 22.9166 9.37492 21.9838 9.37492 20.8333V11.4583C9.37492 10.3077 10.3077 9.37492 11.4583 9.37492Z",
    stroke: "#6A6969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d0acd77bdad32009dc122e0669651ed8.svg";
export { ForwardRef as ReactComponent };